import { Component, OnInit } from "@angular/core";
import { EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { IntegracaoService } from "../integracao.service";

@Component({
    templateUrl: 'scr-controle.component.html',
    styleUrls: ['./scr-controle.component.scss'],
    standalone: false
})
export class ScrControleComponent implements OnInit {

    public controle: any;
    private atributosOrdenacao: EntityOrderedRequestParameters;

    constructor(private integracaoService:IntegracaoService) {
    }
    
    ngOnInit(): void {
       this.atualizar();
    }

    atualizar(): void {
        this.integracaoService.getControle().subscribe((resp) => {
            this.controle = resp;
           });
    }

    getProgressoAtual(): string {
        let total = 0;
        let sucesso = 0;
        if (!this.controle || !this.controle.itens) {
          return "100";
        }
        for (let item of this.controle.itens) {
            total++;
            if (item.dataUltimaAtualizacaoBNDES && item.dataUltimaAtualizacaoBacen <= item.dataUltimaAtualizacaoBNDES) {
                sucesso++;
            }
        }
        return ((sucesso / total) * 100).toPrecision(4);
    }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
        this.atributosOrdenacao = novaOrdenacao;
        this.pesquisarOrdenacao(this.atributosOrdenacao);
    }

    pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
        this.controle.itens = this.controle.itens.sort((a, b) => {
          if (ord.sentido == "asc") {
            return this.compara(a, b, ord.atributo);
          }
          else {
            return -1 * this.compara(a, b, ord.atributo);
          }
        });
      }
    
      private compara(a, b, atributo): number {
        if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
          return 0;
        }
        else {
          if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
            return 1;
          }
          else {
            return -1;
          }
        }
      }

      private fetchFromObject(obj, prop) {

        if(typeof obj === 'undefined') {
          return false;
        }
    
        var _index = prop.indexOf('.')
        if(_index > -1) {
            return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
        }
    
        return obj[prop];
      }

}